import { valibotResolver } from "@hookform/resolvers/valibot";
import { useForm } from "react-hook-form";

import { Button } from "common/components/ui/Button";
import FormField from "common/components/ui/FormField";
import { Input } from "common/components/ui/Input";

import { WHITELABEL_DOMAIN } from "../../constants";
import useAgencySettingsMutations from "../../datahooks/useAgencySettingsMutations";
import {
  CreateAgencyConfigSchema,
  type CreateAgencyConfigSchemaType,
} from "../../schema";

export default function CreateCustomization() {
  const { createAgencySettings, isCreatingAgencySettings } =
    useAgencySettingsMutations();

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm<CreateAgencyConfigSchemaType>({
    resolver: valibotResolver(CreateAgencyConfigSchema),
  });

  function onSubmit(settings: CreateAgencyConfigSchemaType) {
    createAgencySettings({ settings });
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-y-4">
      <FormField
        label="Agency name"
        htmlFor="agency-name"
        error={errors.name?.message}
      >
        <Input
          id="agency-name"
          placeholder="Your agency name"
          className="w-80"
          {...register("name", {
            onChange: (e) => {
              setValue("slug", e.target.value.toLowerCase());
            },
          })}
        />
      </FormField>
      <FormField
        size="md"
        label="Domain name"
        htmlFor="domain-name"
        error={errors.slug?.message}
      >
        <div className="flex items-center gap-x-2 w-80">
          <Input
            id="domain-name"
            placeholder="your-agency-name"
            variant="md"
            className="flex-1"
            {...register("slug")}
          />
          <span className="text-xs-medium">.{WHITELABEL_DOMAIN}</span>
        </div>
      </FormField>
      <Button
        className="ml-auto"
        type="submit"
        isLoading={isCreatingAgencySettings}
      >
        Save
      </Button>
    </form>
  );
}
